import { render, staticRenderFns } from "./BlogGrid.vue?vue&type=template&id=06c6aa44&scoped=true&"
import script from "./BlogGrid.vue?vue&type=script&lang=js&"
export * from "./BlogGrid.vue?vue&type=script&lang=js&"
import style0 from "./BlogGrid.vue?vue&type=style&index=0&id=06c6aa44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c6aa44",
  null
  
)

export default component.exports